module.exports = __webpack_public_path__ + "img/IMG-20200908-WA0044.3052d18b.jpg";